import {Template} from '../../shared/render/template.interface';
import {AutocompleteNode} from '../model/autocomplete-node.model';

export class AutocompleteRecommendationTemplate implements Template {
    link: HTMLElement;
    content: HTMLElement;
    container: HTMLElement;

    constructor(
        private document: Document,
        private autocompleteNode: AutocompleteNode
    ) {
        this.initContainer();
    }

    private initContainer(): void {
        this.container = this.document.createElement('li');
        this.link = this.document.createElement('a');

        this.link.setAttribute('title', this.autocompleteNode.recommendation.summary);
        this.link.setAttribute('href', this.autocompleteNode.recommendation.url);
        this.link.setAttribute('role', 'option');
        this.link.innerHTML = this.autocompleteNode.recommendation.title;

        this.container.classList.add('autocomplete-recommendation');
        this.container.appendChild(this.link);
    }
}